/* eslint-disable no-case-declarations */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useReducer, useRef, useState } from "react";
import { Button, Row, Spinner } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import {
  BiArrowToRight,
  BiAt,
  BiFastForwardCircle,
  BiHome,
  BiInfoCircle,
  BiLeftArrowAlt,
  BiLinkExternal,
  BiPlay,
  BiPlus,
  BiShuffle,
  BiSlideshow,
  BiSolidExit,
  BiSolidHome,
  BiSolidMegaphone,
  BiSolidPlusCircle,
  BiSolidSpreadsheet,
  BiToggleLeft,
  BiUndo,
  BiVideo,
  BiX,
  BiZoomIn,
  BiZoomOut
} from "react-icons/bi";
import { FaMapSigns } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  TransformComponent,
  TransformWrapper,
  useControls
} from "react-zoom-pan-pinch";

import { useAppDispatch, useAppSelector } from "../../../../app/hook";
import { ChatbotRTKService } from "../../../../app/services/chatbot-rtk.services";
import {
  useGetScenarioDetailQuery,
  useModifyScenarioMutation,
  usePublishScenariosMutation
} from "../../../../app/services/scenario-rtk.service";
import { AlertsType } from "../../../../constants/alerts.constant";
import { MultiLanguageUrl } from "../../../../constants/multiLanguage.constant";
import { handleSetLivePreviewTargetBot } from "../../../../features/bot/botSlice";
import {
  selectClient,
  setIsFloatSideMenuShow,
  setSideMenuSize
} from "../../../../features/dashboard.slice";
import {
  selectKnowledgeCreate,
  setChatBotService,
  setEditScenario
} from "../../../../features/knowledge.slice";
import {
  addUndoRedoStep,
  redoStep,
  replaceNewIdInSteps,
  resetUndoRedoScenario,
  selectCurrentStepIndex,
  selectUndoRedoSteps,
  undoStep,
  updateChangedStep
} from "../../../../features/scenario.slice";
import { handleToggleShowUpgradePlanModal } from "../../../../features/ui/uiSlice";
import { BlockType } from "../../../../interfaces/models/Knowledge/scenario.interface";
import IUpdateKnowledgeAssistant from "../../../../interfaces/models/Knowledge/update-knowledge-assistant.interface";
import Utilities from "../../../../utils";
import { BotTypeEnum } from "../../../../utils/BotTypeEnum";
import Alert from "../../../common/Alert";
import { MakeIcon } from "../../../common/icons/make.icon";
import VariableIcon from "../../../common/icons/variable.icon";
import LoadingComponent from "../../../common/loading/loading.component";
import { IRenderCard } from "../../../common/react-drag-hierarchy-tree-main/src/components/interfaces";
import OrgTreeComponent, {
  useTree
} from "../../../common/react-drag-hierarchy-tree-main/src/index";
import {
  ENestedObjectType,
  INestedObject,
  IRenderButton
} from "../../../common/react-drag-hierarchy-tree-main/src/interfaces";
import ScenarioYoutubeVideo from "../../../common/ScenarioYoutubeVideo";
import ProBadge from "../../../ui/ProBadge";
import CreateScenarioTooltip from "../CreateScenarioTooltip";
import { MacBotCreateVariableForm } from "../scenario/scenario-create-variable-form.component";
import { EndConversationForm } from "../scenario/scenario-end-conversation-form.component";
import { MacBotHTTPRequestForm } from "../scenario/scenario-http-request-form.component";
import { MacBotMakeWebHookForm } from "../scenario/scenario-make-webhook.component";
import { MacBotNotifyMeByEmailForm } from "../scenario/scenario-NotifyMeByEmail-form.component";
import { MacBotOverrideVariableForm } from "../scenario/scenario-override-variable-form.component";
import { MacBotPassToAIForm } from "../scenario/scenario-pass-to-ai-form.component";
import { MacBotReceiveAttachmentForm } from "../scenario/scenario-ReceiveAttachment-form.component";
import { MacBotSwitchToChatbotForm } from "../scenario/scenario-switch-to-chatbot-form.component";
import { IMacBotAction, IMacBotState, MacBotActionKind } from "../types";
import TreeNode from "./TreeNode";
import { MacBotAttachmentForm } from "./video-scenario-attachment-form.component";
import { MacBotButtonForm } from "./video-scenario-button-form.component";
import { MacBotConditionForm } from "./video-scenario-condition-form.component";
import { ScenarioDeleteConfirm } from "./video-scenario-delete-confirmation";
import { MacBotGotoForm } from "./video-scenario-goto-form.component";
import { MacBotLeadForm } from "./video-scenario-lead-form.component";
import { TextScenarioLinkForm } from "./video-scenario-link-form.component";
import { MacBotMediaForm } from "./video-scenario-media-form.component";
import { VideoScenarioResponseForm } from "./video-scenario-response-form.component";
import { MacBotUserInputForm } from "./video-scenario-user-input-form.component";
import { MacBotVariableForm } from "./video-scenario-variable-form.component";

export type AcceptableItemsToAddType =
  | "START_POINT"
  | "BOT_MESSAGE"
  | "ADD_BUTTON"
  | "ADD_LINK"
  | "ASSIGN_VARIABLE"
  | "HTTP_REQUEST"
  | "SWITCH_TO_CHATBOT"
  | "MAKE_WEBHOOK"
  | "CONDITIONS"
  | "CONDITION_ELSE"
  | "CREATE_VARIABLE"
  | "OVERRIDE_VARIABLE"
  | "NOTIFY_ME_BY_EMAIL"
  | "LEAD_FORM"
  | "END_OF_CONVERSATION"
  | "GO_TO";

// Our reducer function that uses a switch statement to handle our actions
function MacBotReducer(state: IMacBotState, action: IMacBotAction) {
  const { type, payload } = action;
  switch (type) {
    case MacBotActionKind.ShowElseForm:
      return {
        ...state,
        isShowElseForm: false,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowResponseForm:
      return {
        ...state,
        isShowResponseForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowButtonForm:
      return {
        ...state,
        isShowButtonForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowUserInputForm:
      return {
        ...state,
        isShowUserInputForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowVariableForm:
      return {
        ...state,
        isShowVariableForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowGotoForm:
      return {
        ...state,
        isShowGotoForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowLINKForm:
      return {
        ...state,
        isShowLinkForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowHTTPRequestForm:
      return {
        ...state,
        isShowHTTPRequestForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowMakeWebHookForm:
      return {
        ...state,
        isShowMakeWebHookForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowConditionForm:
      return {
        ...state,
        isShowConditionForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowOverrideVariableForm:
      return {
        ...state,
        isShowOverrideVariableForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowCreateVariableForm:
      return {
        ...state,
        isShowCreateVariableForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowLeadForm:
      return {
        ...state,
        isShowLeadForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowMediaForm:
      return {
        ...state,
        isShowMediaForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowEndOfConversationForm:
      return {
        ...state,
        isShowEndOfConversationForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowNotifyMeByEmail:
      return {
        ...state,
        isShowNotifyMeByEmailForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowAttachmentForm:
      return {
        ...state,
        isShowAttachmentForm: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowUserCredential:
      return {
        ...state,
        isShowUserCredential: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowPassToAi:
      return {
        ...state,
        isShowPassToAi: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.ShowSwitchToChatbot:
      return {
        ...state,
        isShowSwitchToChatbot: true,
        data: payload.data,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    case MacBotActionKind.CloseForm:
      return {
        ...state,
        isShowGotoForm: false,
        isShowUserInputForm: false,
        isShowResponseForm: false,
        isShowElseForm: false,
        isShowLinkForm: false,
        isShowButtonForm: false,
        isShowVariableForm: false,
        isShowHTTPRequestForm: false,
        isShowConditionForm: false,
        isShowOverrideVariableForm: false,
        isShowCreateVariableForm: false,
        isShowNotifyMeByEmailForm: false,
        isShowLeadForm: false,
        isShowMakeWebHookForm: false,
        isShowMediaForm: false,
        isShowAttachmentForm: false,
        isShowEndOfConversationForm: false,
        isShowDelayForm: false,
        isShowPassToAi: false,
        isShowSwitchToChatbot: false,
        data: null,
        parentId: payload?.parentId ? payload?.parentId : null
      } as IMacBotState;
    default:
      return state;
  }
}

const VideoScenarioComponent = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const createState = useAppSelector(selectKnowledgeCreate);
  const client = useAppSelector(selectClient);
  const currentScenarioId = useAppSelector((state) => state.bots.wizard.id);
  const undoRedoSteps = useAppSelector(selectUndoRedoSteps);
  const currentStepIndex = useAppSelector(selectCurrentStepIndex);
  const { botConfigs } = useAppSelector(selectClient);

  const [videoScenarioAllowedBlocks, setVideoScenarioAllowedBlocks] = useState(
    botConfigs
      ? botConfigs.find(
          (config: any) => config.botName === BotTypeEnum.VIDEO_SCENARIO
        ).config.allowedBlocks
      : []
  );

  const [scale, setScale] = useState<number>(1);
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [isLivePreview, setIsLivePreview] = useState(false);
  const [isLivePreviewLoading, setIsLivePreviewLoading] = useState(false);
  const [fetChGetScenarioDetail, setFetchGetScenarioDetail] = useState(false);
  const [treeData, setTreeData] = useState<any[]>([]);
  const [configData, setConfigData] = useState<any>(null);
  const [showPlusModal, setShowPlusModal] = useState(false);
  const [acceptableBlocksToAdd, setAcceptableBlocksToAdd] = useState<
    Array<AcceptableItemsToAddType>
  >([]);
  const [targetBlockToAddToId, setTargetBlockToAddToId] = useState("");

  const setShowResponse = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowResponseForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowUserInput = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowUserInputForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowGoto = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowGotoForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowElse = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowElseForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowButton = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowButtonForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowLink = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowLINKForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowVariable = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowVariableForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowHTTPRequest = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowHTTPRequestForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowWebHook = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowMakeWebHookForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowCondition = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowConditionForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowNotifyMeByEmail = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowNotifyMeByEmail,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowOverrideVariable = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowOverrideVariableForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowCreateVariable = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowCreateVariableForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowLead = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowLeadForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowMedia = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowMediaForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowAttachment = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowAttachmentForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowEndConversation = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowEndOfConversationForm,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowPassToAI = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowPassToAi,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };
  const setShowSwitchToChatbot = () => {
    MacBotDispatch({
      type: MacBotActionKind.ShowSwitchToChatbot,
      payload: { data: null, parentId: targetBlockToAddToId }
    });
  };

  const addBlockUiComponents = {
    START_POINT: {
      icon: <BiSolidHome className="tw-text-gray-800" size={22} />,
      label: "Start Point",
      description: "",
      colors: {
        primary: "#9ca3af",
        secondary: "#D1D5DBA3",
        text: "#1f2937"
      },
      action: () => {
        setShowUserInput();
      },
      type: ENestedObjectType.Start
    },

    ELSE: {
      icon: <FaMapSigns className="tw-text-gray-800" size={22} />,
      label: "ELSE",
      description: "",
      colors: {
        primary: "#9ca3af",
        secondary: "#D1D5DBA3",
        text: "#1f2937"
      },
      action: () => {
        setShowElse();
      },
      type: ENestedObjectType.Else
    },

    BOT_MESSAGE: {
      icon: <BiVideo className="tw-text-gray-800" size={22} />,
      label: t("AddItemModal/key17"),
      description: t("AddItemModal/desc17"),
      colors: {
        primary: "#93c5fd",
        secondary: "#93c5fd",
        text: "#1f2937"
      },
      action: setShowResponse,
      type: ENestedObjectType.VideoBlock
    },

    ADD_BUTTON: {
      icon: <BiToggleLeft className="tw-text-gray-800" size={22} />,
      label: t("AddItemModal/key5"),
      description: t("AddItemModal/desc5"),
      colors: {
        primary: "#67e8f9",
        secondary: "#67e8f9",
        text: "#1f2937"
      },
      action: setShowButton,
      type: ENestedObjectType.VideoButton
    },

    ADD_LINK: {
      icon: <BiLinkExternal className="tw-text-gray-800" size={22} />,
      label: t("AddItemModal/key6"),
      description: t("AddItemModal/desc6"),
      colors: {
        primary: "#67e8f9",
        secondary: "#67e8f9",
        text: "#1f2937"
      },
      action: setShowLink,
      type: ENestedObjectType.VideoLink
    },
    CREATE_VARIABLE: {
      icon: <VariableIcon size={22} />,
      label: t("AddItemModal/key7"),
      description: t("AddItemModal/desc7"),
      colors: {
        primary: "#6ee7b7",
        secondary: "#6ee7b7",
        text: "#1f2937"
      },
      action: setShowCreateVariable,
      type: ENestedObjectType.CreateVariable
    },

    OVERRIDE_VARIABLE: {
      icon: <BiArrowToRight className="tw-text-gray-800" size={22} />,
      label: t("AddItemModal/key9"),
      description: t("AddItemModal/desc9"),
      colors: {
        primary: "#6ee7b7",
        secondary: "#6ee7b7",
        text: "#1f2937"
      },
      action: setShowOverrideVariable,
      type: ENestedObjectType.OverrideVariable
    },
    CONDITIONS: {
      icon: <BiShuffle className="tw-text-gray-800" size={22} />,
      label: t("AddItemModal/key11"),
      description: t("AddItemModal/desc11"),
      colors: {
        primary: "#6ee7b7",
        secondary: "#6ee7b7",
        text: "#1f2937"
      },
      action: setShowCondition,
      type: ENestedObjectType.Condition
    },
    CONDITION_ELSE: {
      icon: <BiShuffle className="tw-text-gray-800" size={22} />,
      label: t("AddItemModal/key11"),
      description: t("AddItemModal/desc11"),
      colors: {
        primary: "#6ee7b7",
        secondary: "#6ee7b7",
        text: "#1f2937"
      },
      action: setShowElse,
      type: ENestedObjectType.ConditionElse
    },
    HTTP_REQUEST: {
      icon: <BiSolidMegaphone className="tw-text-gray-800" size={22} />,
      label: t("AddItemModal/key10"),
      description: t("AddItemModal/desc10"),
      colors: {
        primary: "#fdba74",
        secondary: "#fdba74",
        text: "#1f2937"
      },
      action: setShowHTTPRequest,
      type: ENestedObjectType.Http
    },
    MAKE_WEBHOOK: {
      icon: <MakeIcon className="tw-text-gray-800" size={22} />,
      label: t("MacMakeCom/key1"),
      description: t("MacMakeCom/desc1"),
      colors: {
        primary: "#fdba74",
        secondary: "#fdba74",
        text: "#1f2937"
      },
      action: setShowWebHook,
      type: ENestedObjectType.MakeWebHook
    },
    NOTIFY_ME_BY_EMAIL: {
      icon: <BiAt size={22} />,
      label: t("MacNotifyEmail/key1"),
      description: t("MacNotifyEmail/desc1"),
      colors: {
        primary: "#fdba74",
        secondary: "#fdba74",
        text: "#1f2937"
      },
      action: setShowNotifyMeByEmail,
      type: ENestedObjectType.NotifyMeByEmail
    },
    LEAD_FORM: {
      icon: <BiSolidSpreadsheet className="tw-text-gray-800" size={22} />,
      label: t("AddItemModal/key13"),
      description: t("AddItemModal/desc13"),
      colors: {
        primary: "#c4b5fd",
        secondary: "#c4b5fd",
        text: "#1f2937"
      },
      action: setShowLead,
      type: ENestedObjectType.Lead
    },
    SWITCH_TO_CHATBOT: {
      icon: <BiFastForwardCircle size={22} />,
      label: t("SwitchToChatbot/Title"),
      description: t("SwitchToChatbot/Description"),
      colors: {
        primary: "#a49ad6",
        secondary: "#c5bde1",
        text: "#1f2937"
      },
      action: setShowSwitchToChatbot,
      type: ENestedObjectType.SwitchToChatbot
    },
    GO_TO: {
      icon: <BiUndo className="tw-text-gray-800" size={22} />,
      label: t("AddItemModal/key14"),
      description: t("AddItemModal/desc14"),
      colors: {
        primary: "#fda4af",
        secondary: "#fda4af",
        text: "#1f2937"
      },
      action: setShowGoto,
      type: ENestedObjectType.VideGoto
    },

    END_OF_CONVERSATION: {
      icon: <BiSolidExit className="tw-text-gray-800" size={22} />,
      label: t("AddItemModal/key15"),
      description: t("AddItemModal/desc15"),
      colors: {
        primary: "#fda4af",
        secondary: "#fda4af",
        text: "#1f2937"
      },
      action: setShowEndConversation,
      type: ENestedObjectType.EndOfConversation
    }
  };

  const useRefIframe = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    // Set up event listener for messages from the iframe
    const handleMessage = (event: any) => {
      // Ensure the message is coming from the expected origin
      if (
        event.origin == `${import.meta.env.VITE_CHATBOT_WIDGET}` &&
        event?.data == "CloseLivePreview"
      ) {
        setIsLivePreview(false);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (isMobile || window.screen.width <= 480) {
      setIsLivePreview(false);
    }
  }, [isMobile]);

  const {
    isLoading,
    isError,
    isSuccess,
    isFetching,
    data: getScenarioDetailData,
    refetch
  } = useGetScenarioDetailQuery(`${currentScenarioId}`);

  useEffect(() => {
    dispatch(setIsFloatSideMenuShow(false));
    dispatch(setSideMenuSize("sm"));

    const showModal = localStorage.getItem("VSBuilderMobileModal");
    if (showModal && JSON.parse(showModal) === client?.sum_identification)
      setShowMobileModal(false);
    else setShowMobileModal(true);
  }, []);

  const [MacBotState, MacBotDispatch] = useReducer(MacBotReducer, {
    parentId: null,
    data: null,
    isShowElseForm: false,
    isShowResponseForm: false,
    isShowUserInputForm: false,
    isShowGotoForm: false,
    isShowButtonForm: false,
    isShowLinkForm: false,
    isShowVariableForm: false,
    isShowHTTPRequestForm: false,
    isShowMakeWebHookForm: false,
    isShowConditionForm: false,
    isShowOverrideVariableForm: false,
    isShowCreateVariableForm: false,
    isShowLeadForm: false,
    isShowMediaForm: false,
    isShowAttachmentForm: false,
    isShowDelayForm: false,
    isShowEndOfConversationForm: false,
    isShowNotifyMeByEmailForm: false,
    isShowReceiveAttachmentForm: false,
    isShowPassToAi: false,
    isShowSwitchToChatbot: false,
    isShowCheckIfUserExists: false,
    isShowGetUserInfo: false,
    isShowRegisterUser: false,
    isShowSuperUserManagerServices: false,
    isShowUserCredential: false,
    isShowFrom: false
  } as IMacBotState);

  const [isLoadingPage, setIsLoadingPage] = useState(true);

  const [modifyScenario, modifyScenarioStatus] = useModifyScenarioMutation();

  const [publishScenario] = usePublishScenariosMutation();

  useEffect(() => {
    const handleContextmenu = (e: any) => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextmenu);
    return function cleanup() {
      document.removeEventListener("contextmenu", handleContextmenu);
    };
  }, []);

  useEffect(() => {
    if (isSuccess) {
      setIsLoadingPage(isLoading);
    }
  }, [isLoading, isSuccess]);

  const [data, setData] = useState<INestedObject>({
    id: "Start",
    title: "Start Point",
    type: ENestedObjectType.Start,
    children: []
  });

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("HomeButton")?.click();
    }, 1000);
  }, []);

  const { treeRef } = useTree();

  const click = (data: any, type: number) => {
    switch (type) {
      case ENestedObjectType.VideoBlock:
        MacBotDispatch({
          type: MacBotActionKind.ShowResponseForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.VideoButton:
        MacBotDispatch({
          type: MacBotActionKind.ShowButtonForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.Else:
        MacBotDispatch({
          type: MacBotActionKind.ShowElseForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.UserInput:
        MacBotDispatch({
          type: MacBotActionKind.ShowUserInputForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.VideoLink:
        MacBotDispatch({
          type: MacBotActionKind.ShowLINKForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.Variable:
        MacBotDispatch({
          type: MacBotActionKind.ShowVariableForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.Http:
        MacBotDispatch({
          type: MacBotActionKind.ShowHTTPRequestForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.MakeWebHook:
        MacBotDispatch({
          type: MacBotActionKind.ShowMakeWebHookForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.Condition:
        MacBotDispatch({
          type: MacBotActionKind.ShowConditionForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.OverrideVariable:
        MacBotDispatch({
          type: MacBotActionKind.ShowOverrideVariableForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.CreateVariable:
        MacBotDispatch({
          type: MacBotActionKind.ShowCreateVariableForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.Lead:
        MacBotDispatch({
          type: MacBotActionKind.ShowLeadForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.Media:
        MacBotDispatch({
          type: MacBotActionKind.ShowMediaForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.Attachment:
        MacBotDispatch({
          type: MacBotActionKind.ShowAttachmentForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.EndOfConversation:
        MacBotDispatch({
          type: MacBotActionKind.ShowEndOfConversationForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.VideGoto:
        MacBotDispatch({
          type: MacBotActionKind.ShowGotoForm,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.NotifyMeByEmail:
        MacBotDispatch({
          type: MacBotActionKind.ShowNotifyMeByEmail,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.ReceiveAttachment:
        MacBotDispatch({
          type: MacBotActionKind.ShowReceiveAttachment,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.PassToAI:
        MacBotDispatch({
          type: MacBotActionKind.ShowPassToAi,
          payload: { data, parentId: data.id }
        });
        break;
      case ENestedObjectType.SwitchToChatbot:
        MacBotDispatch({
          type: MacBotActionKind.ShowSwitchToChatbot,
          payload: { data, parentId: data.id }
        });
        break;
      default:
        MacBotDispatch({ type: MacBotActionKind.CloseForm, payload: null });
    }
  };

  const ResetLivePreview = () => {
    const iframe = useRefIframe.current;

    iframe?.contentWindow?.postMessage(
      "ResetLivePreview",
      `${import.meta.env.VITE_CHATBOT_WIDGET}`
    );
  };

  const hasTrueShowKey = (object: Record<string, any>) => {
    for (const key in object) {
      if (key.startsWith("isShow") && object[key] === true) {
        return true;
      }
    }
    return false;
  };

  const renderCard = (item: IRenderCard) => {
    const {
      data: { type, id, notes, ...rest }
    } = item;

    const features: Record<
      string,
      {
        name: AcceptableItemsToAddType;
        id: string;
        icon: React.ReactNode;
        acceptableBlocks: AcceptableItemsToAddType[];
        label: React.ReactNode;
        colors: {
          primary: string;
          secondary: string;
          text: string;
        };
      }
    > = {
      [ENestedObjectType.Start]: {
        name: "START_POINT",
        id: "STARTBUTTON",
        icon: addBlockUiComponents["START_POINT"].icon,
        acceptableBlocks: ["BOT_MESSAGE"],
        label: t("KnowledgeBasesCreateConditionalScenario/text-05"),
        colors: addBlockUiComponents["START_POINT"].colors
      },
      [ENestedObjectType.VideoBlock]: {
        name: "BOT_MESSAGE",
        id: "",
        icon: addBlockUiComponents["BOT_MESSAGE"].icon,
        acceptableBlocks: [
          "ADD_BUTTON",
          "ADD_LINK",
          "END_OF_CONVERSATION",
          "CREATE_VARIABLE",
          "OVERRIDE_VARIABLE"
        ],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            <span title={rest.title}>{rest.title}</span>
          </>
        ),
        colors: addBlockUiComponents["BOT_MESSAGE"].colors
      },
      [ENestedObjectType.VideGoto]: {
        name: "GO_TO",
        id: "",
        icon: addBlockUiComponents["GO_TO"].icon,
        acceptableBlocks: ["BOT_MESSAGE"],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            {treeData?.find((dr: any) => dr.id == item.data.next)?.title
              ?.length > 20
              ? treeData
                  ?.find((dr: any) => dr.id == item.data.next)
                  ?.title?.slice(0, 20) + "..."
              : treeData?.find((dr: any) => dr.id == item.data.next)?.title}
          </>
        ),
        colors: addBlockUiComponents["GO_TO"].colors
      },
      [ENestedObjectType.VideoButton]: {
        name: "ADD_BUTTON",
        id: "",
        icon: addBlockUiComponents["ADD_BUTTON"].icon,
        acceptableBlocks: [
          "BOT_MESSAGE",
          "HTTP_REQUEST",
          "NOTIFY_ME_BY_EMAIL",
          "MAKE_WEBHOOK",
          "SWITCH_TO_CHATBOT",
          "CONDITIONS",
          "CREATE_VARIABLE",
          "OVERRIDE_VARIABLE",
          "LEAD_FORM",
          "GO_TO"
        ],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            {rest.title ?? ""}
          </>
        ),
        colors: addBlockUiComponents["ADD_BUTTON"].colors
      },

      [ENestedObjectType.SwitchToChatbot]: {
        name: "SWITCH_TO_CHATBOT",
        id: "",
        icon: addBlockUiComponents["SWITCH_TO_CHATBOT"].icon,
        acceptableBlocks: [],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            <span title={rest.title}>{rest.title}</span>
          </>
        ),
        colors: addBlockUiComponents["SWITCH_TO_CHATBOT"].colors
      },
      [ENestedObjectType.VideoLink]: {
        name: "ADD_LINK",
        id: "",
        icon: addBlockUiComponents["ADD_LINK"].icon,
        acceptableBlocks: ["END_OF_CONVERSATION"],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            {rest.title ?? ""}
          </>
        ),
        colors: addBlockUiComponents["ADD_LINK"].colors
      },
      [ENestedObjectType.Http]: {
        name: "HTTP_REQUEST",
        id: "",
        icon: addBlockUiComponents["HTTP_REQUEST"].icon,
        acceptableBlocks: [
          "BOT_MESSAGE",
          "HTTP_REQUEST",
          "NOTIFY_ME_BY_EMAIL",
          "MAKE_WEBHOOK",
          "SWITCH_TO_CHATBOT",
          "CONDITIONS",
          "CREATE_VARIABLE",
          "OVERRIDE_VARIABLE",
          "LEAD_FORM",
          // "DELAY",
          "END_OF_CONVERSATION",
          "GO_TO"
        ],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            {rest.title ?? ""}
          </>
        ),
        colors: addBlockUiComponents["HTTP_REQUEST"].colors
      },
      [ENestedObjectType.MakeWebHook]: {
        name: "MAKE_WEBHOOK",
        id: "",
        icon: addBlockUiComponents["MAKE_WEBHOOK"].icon,
        acceptableBlocks: [
          "BOT_MESSAGE",
          "HTTP_REQUEST",
          "NOTIFY_ME_BY_EMAIL",
          "MAKE_WEBHOOK",
          "CONDITIONS",
          "CREATE_VARIABLE",
          "SWITCH_TO_CHATBOT",
          "OVERRIDE_VARIABLE",
          "LEAD_FORM",
          "END_OF_CONVERSATION",
          "GO_TO"
        ],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            {rest.title ?? ""}
          </>
        ),
        colors: addBlockUiComponents["MAKE_WEBHOOK"].colors
      },
      [ENestedObjectType.NotifyMeByEmail]: {
        name: "NOTIFY_ME_BY_EMAIL",
        id: "",
        icon: addBlockUiComponents["NOTIFY_ME_BY_EMAIL"].icon,
        acceptableBlocks: [
          "BOT_MESSAGE",
          "NOTIFY_ME_BY_EMAIL",
          "ADD_BUTTON",
          "ADD_LINK",
          "ASSIGN_VARIABLE",
          "HTTP_REQUEST",
          "MAKE_WEBHOOK",
          "SWITCH_TO_CHATBOT",
          "CONDITIONS",
          "OVERRIDE_VARIABLE",
          "CREATE_VARIABLE",
          "LEAD_FORM",
          "END_OF_CONVERSATION",
          "GO_TO"
        ],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            <span title={rest.title}>{rest.title}</span>
          </>
        ),
        colors: addBlockUiComponents["NOTIFY_ME_BY_EMAIL"].colors
      },
      [ENestedObjectType.Condition]: {
        name: "CONDITIONS",
        id: "",
        icon: addBlockUiComponents["CONDITIONS"].icon,
        acceptableBlocks: [
          "BOT_MESSAGE",
          "HTTP_REQUEST",
          "NOTIFY_ME_BY_EMAIL",
          "MAKE_WEBHOOK",
          "SWITCH_TO_CHATBOT",
          "CONDITIONS",
          "CREATE_VARIABLE",
          "OVERRIDE_VARIABLE",
          "LEAD_FORM",
          "GO_TO"
        ],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            {rest.title ?? ""}
          </>
        ),
        colors: addBlockUiComponents["CONDITIONS"].colors
      },
      [ENestedObjectType.ConditionElse]: {
        name: "CONDITION_ELSE",
        id: "",
        icon: addBlockUiComponents["CONDITION_ELSE"].icon,
        acceptableBlocks: [
          "BOT_MESSAGE",
          "HTTP_REQUEST",
          "NOTIFY_ME_BY_EMAIL",
          "MAKE_WEBHOOK",
          "SWITCH_TO_CHATBOT",
          "CONDITIONS",
          "CREATE_VARIABLE",
          "OVERRIDE_VARIABLE",
          "LEAD_FORM",
          "GO_TO"
        ],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            {rest.title ?? ""}
          </>
        ),
        colors: addBlockUiComponents["CONDITION_ELSE"].colors
      },
      [ENestedObjectType.EndOfConversation]: {
        name: "END_OF_CONVERSATION",
        id: "",
        icon: addBlockUiComponents["END_OF_CONVERSATION"].icon,
        acceptableBlocks: [],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            {rest.title ?? ""}
          </>
        ),
        colors: addBlockUiComponents["END_OF_CONVERSATION"].colors
      },
      [ENestedObjectType.OverrideVariable]: {
        name: "OVERRIDE_VARIABLE",
        id: "",
        icon: addBlockUiComponents["OVERRIDE_VARIABLE"].icon,
        acceptableBlocks: [
          "BOT_MESSAGE",
          "HTTP_REQUEST",
          "NOTIFY_ME_BY_EMAIL",
          "MAKE_WEBHOOK",
          "SWITCH_TO_CHATBOT",
          "CONDITIONS",
          "CREATE_VARIABLE",
          "OVERRIDE_VARIABLE",
          "LEAD_FORM",
          "GO_TO"
        ],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            {rest.title ?? ""}
          </>
        ),
        colors: addBlockUiComponents["OVERRIDE_VARIABLE"].colors
      },
      [ENestedObjectType.CreateVariable]: {
        name: "CREATE_VARIABLE",
        id: "",
        icon: addBlockUiComponents["CREATE_VARIABLE"].icon,
        acceptableBlocks: [
          "BOT_MESSAGE",
          "HTTP_REQUEST",
          "NOTIFY_ME_BY_EMAIL",
          "MAKE_WEBHOOK",
          "SWITCH_TO_CHATBOT",
          "CONDITIONS",
          "OVERRIDE_VARIABLE",
          "CREATE_VARIABLE",
          "LEAD_FORM",
          "GO_TO"
        ],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            {rest.title ?? ""}
          </>
        ),
        colors: addBlockUiComponents["CREATE_VARIABLE"].colors
      },
      [ENestedObjectType.Lead]: {
        name: "LEAD_FORM",
        id: "",
        icon: addBlockUiComponents["LEAD_FORM"].icon,
        acceptableBlocks: [
          "BOT_MESSAGE",
          "HTTP_REQUEST",
          "NOTIFY_ME_BY_EMAIL",
          "MAKE_WEBHOOK",
          "CONDITIONS",
          "OVERRIDE_VARIABLE",
          "CREATE_VARIABLE",
          "END_OF_CONVERSATION",
          "GO_TO"
        ],
        label: (
          <>
            <span className="tw-text-primary">{rest.block_id}</span>{" "}
            {rest.title ?? ""}
          </>
        ),
        colors: addBlockUiComponents["LEAD_FORM"].colors
      }
    };

    if (typeof type === "undefined") return null;

    const excludedBlockTypes = [
      BlockType.EndOFConversation,
      BlockType.Goto,
      BlockType.VideGoto,
      BlockType.Start,
      BlockType.PassToAi,
      BlockType.SwitchToChatbot
    ];

    return (
      <TreeNode
        originalRenderData={item}
        data={features[+type]}
        onClickToEdit={(data, type) => {
          MacBotDispatch({
            type: MacBotActionKind.CloseForm,
            payload: { data: null, parentId: MacBotState.parentId }
          });

          setIsLivePreview(false);
          setShowPlusModal(false);

          click(data, type);
        }}
        isActive={id === MacBotState.parentId && hasTrueShowKey(MacBotState)}
        notes={notes}
      >
        {!excludedBlockTypes.includes(+type) && (
          <button
            onClick={() => {
              MacBotDispatch({
                type: MacBotActionKind.CloseForm,
                payload: { data: null, parentId: MacBotState.parentId }
              });
              setShowPlusModal(true);
              setTargetBlockToAddToId(id as string);
              setAcceptableBlocksToAdd(features[+type].acceptableBlocks);
              setIsLivePreview(false);
            }}
            type="button"
            className="tw-border-none tw-bg-transparent tw-p-0 tw-flex tw-items-center"
          >
            <div className="tw-w-8 tw-h-[5px] tw-bg-[#C1C8CD] tw-relative tw-top-[-1px]" />
            <div
              className={`tw-rounded-full tw-shrink-0 tw-flex-tw-flex-col tw-items-center tw-justify-center ${
                showPlusModal && targetBlockToAddToId === id
                  ? "tw-bg-white tw-border-solid tw-border-4 tw-border-blue-600 tw-p-[0.4px] tw-w-8 tw-h-8"
                  : type !== 20 &&
                    type !== 3 &&
                    item?.data?.childrens?.length <= 0
                  ? "tw-bg-white tw-border-solid tw-border-4 tw-border-red-600 tw-p-[0.4px] tw-w-8 tw-h-8 blink"
                  : "tw-border-none"
              } `}
            >
              <BiSolidPlusCircle
                size={22}
                className={`tw-text-gray-400 tw-relative ${
                  (showMobileModal && targetBlockToAddToId === id) ||
                  (type !== 20 &&
                    type !== 3 &&
                    item?.data?.childrens?.length <= 0)
                    ? "tw-top-[-2px]"
                    : ""
                }`}
              />
            </div>
          </button>
        )}
      </TreeNode>
    );
  };

  const renderButton = (item: IRenderButton) => {
    return <div></div>;
  };

  const setLastTree = (step: any) => {
    dispatch(addUndoRedoStep({ step }));
  };

  const undoHandler = () => {
    const targetStep = undoRedoSteps[currentStepIndex];
    let action = "";
    switch (targetStep?.action) {
      case "add":
        action = "remove";
        break;
      case "remove":
        action = "add";
        break;
      case "change":
        action = "change";
        break;

      default:
        return;
    }

    undoRedoModifyHandler("undo", action, targetStep.data);
  };

  const redoHandler = () => {
    const targetStep = undoRedoSteps[currentStepIndex + 1];
    let action = "";

    switch (targetStep?.action) {
      case "add":
        action = "remove";
        break;
      case "remove":
        action = "add";
        break;
      case "change":
        action = "change";
        break;

      default:
        return;
    }

    undoRedoModifyHandler("redo", action, targetStep.data);
  };

  const undoRedoModifyHandler = (
    type: "redo" | "undo",
    action: string,
    data: any
  ) => {
    const { children, ...dataNoChild } = data;
    const { id, next, ...restData } = dataNoChild;
    let _data = {};
    switch (action) {
      case "remove":
        if (data.type === ENestedObjectType.Else) {
          _data = {
            batch: {
              remove: [id]
            }
          };
        } else {
          _data = {
            single: {
              action,
              data: { id }
            }
          };
        }
        break;
      case "add":
        _data = {
          single: {
            action,
            data:
              dataNoChild.type == ENestedObjectType.Goto
                ? { ...restData, next }
                : restData
          }
        };
        break;
      default:
        _data = {
          single: {
            action,
            data: dataNoChild
          }
        };
        break;
    }

    modifyScenario({
      scenarioId: `${currentScenarioId}`,
      data: { ..._data }
    })
      .unwrap()
      .then((res) => {
        if (action === "add") {
          // replace ID of new created block as all parent IDs
          dispatch(
            replaceNewIdInSteps({
              newId: res?.config?.tree.slice(-1)[0]?.id,
              exId: id
            })
          );
        } else if (action === "change") {
          dispatch(
            updateChangedStep({
              type,
              step: treeData.find((dr: any) => dr.id == id)
            })
          );
        }

        if (type === "undo") {
          dispatch(undoStep());
        } else {
          dispatch(redoStep());
        }
        setDataToChart(res);
      })
      .catch((res) => {
        if (res.status == 403) {
          toast.error(t(AlertsType.ISGLOK001), {
            delay: 100
          });
        } else {
          toast.error(t(AlertsType.ISKBKO013), { delay: 100 });
        }
      });
  };

  useEffect(() => {
    if (isSuccess && currentScenarioId && !isFetching) {
      if (getScenarioDetailData?.type == BotTypeEnum.TEXT_SCENARIO) {
        return navigate(`?type=text-scenario`);
      }
      setDataToChart(getScenarioDetailData);
    }
  }, [currentScenarioId, isSuccess, isFetching]);

  const setDataToChart = (dataNodes: any) => {
    ResetLivePreview();

    const temp = JSON.parse(JSON.stringify(data));

    const tempData = JSON.parse(JSON.stringify(dataNodes));

    if (tempData?.config?.tree) {
      const length = (tempData?.config?.tree as any[]).length;
      if (length > 50) {
        setScale(0.5);
      } else {
        setScale(0.8);
      }

      setTreeData([...tempData.config.tree]);
      setConfigData(tempData.config);
    }

    const response = createNestedStructure(tempData.config?.tree || []);

    temp.children = response;

    setData(temp);
  };

  function createNestedStructure(accounts: any[], parentId = null) {
    const result = [];

    for (const account of accounts) {
      if (account.parent === parentId) {
        const children = createNestedStructure(accounts, account.id);
        if (children.length > 0) {
          let childrenTemp = children?.sort(
            (a, b) => a?.order_id - b?.order_id
          );

          if (
            childrenTemp.length > 1 &&
            childrenTemp.find((dr) => dr.type == 0)
          ) {
            childrenTemp = childrenTemp.reverse();
          }

          account.children = childrenTemp;
        }
        result.push(account);
      }
    }

    return result;
  }

  const editable = () => {
    setEditScenario;
    dispatch(
      setEditScenario({
        botService: createState.chatbotService,
        id: currentScenarioId,
        chatbotTitle: createState.chatbotTitle
      } as unknown as IUpdateKnowledgeAssistant)
    );

    dispatch(setChatBotService(createState.chatbotService));
  };

  const createScenarioBlock = (block: any) => {
    return new Promise<void>((resolve, reject) => {
      editable();
      //setFetchGetScenarioDetail(true);
      modifyScenario({
        scenarioId: `${currentScenarioId}`,
        data: {
          single: {
            action: "add",
            data: {
              ...Utilities.setBlockNotes(block),
              block_id: Utilities.createBlockId(block.title, treeData)
            }
          }
        }
      })
        .unwrap()
        .then((data) => {
          toast.success(t("General/key10"));

          setLastTree({
            action: "add",
            data: {
              ...data?.config?.tree[data?.config?.tree?.length - 1],
              block_id: Utilities.createBlockId(block.title, treeData)
            }
          });

          MacBotDispatch({
            type: MacBotActionKind.CloseForm,
            payload: { data: null, parentId: null }
          });

          setDataToChart(data);

          resolve(data);
        })
        .catch((res) => {
          if (res.status < 500) {
            const messagesList = res?.data?.element
              ?.map((el: any) =>
                Object.entries(el.messages)?.map(([key, value]) => `${value}`)
              )
              .flat();

            if (messagesList) {
              for (const message of messagesList) {
                toast.warn(message);
              }
            } else {
              toast.warn(res?.data?.message || res.message);
            }
          }

          if (res.status >= 500) toast.error(res?.data?.message || res.message);

          // let errorMessage = res?.data?.message || t(AlertsType.ISGLOK001);
          // if (res.status == 403) {
          //   errorMessage = t(AlertsType.ISGLOK001);
          // }
          // toast.error(errorMessage, { delay: 100 });

          reject(res);
        });
    });
  };

  const changeScenarioBlock = (
    block: any,
    isUpdateTree = true,
    isUndoRedoState = true
  ) => {
    return new Promise<void>((resolve, reject) => {
      editable();
      //setFetchGetScenarioDetail(true);
      const { children, ...dataNoChild } = Utilities.setBlockNotes(block);
      modifyScenario({
        scenarioId: `${currentScenarioId}`,
        data: {
          single: {
            action: "change",
            data: dataNoChild
          }
        }
      })
        .unwrap()
        .then((data) => {
          toast.success(t("General/key11"));

          if (isUndoRedoState) {
            setLastTree({
              action: "change",
              data: treeData.find((dr: any) => dr.id == block.id)
            });
          }

          MacBotDispatch({
            type: MacBotActionKind.CloseForm,
            payload: { data: null, parentId: null }
          });

          if (isUpdateTree) {
            setDataToChart(data);
          }

          resolve(data);
        })
        .catch((res) => {
          if (res.status < 500) {
            const messagesList = res?.data?.element
              ?.map((el: any) =>
                Object.entries(el.messages)?.map(([key, value]) => `${value}`)
              )
              .flat();

            if (messagesList) {
              for (const message of messagesList) {
                toast.warn(message);
              }
            } else {
              toast.warn(res?.data?.message || res.message);
            }
          }

          if (res.status >= 500) toast.error(res?.data?.message || res.message);

          // let errorMessage = res?.data?.message || t(AlertsType.ISGLOK001);
          // if (res.status == 403) {
          //   errorMessage = t(AlertsType.ISGLOK001);
          // }
          // toast.error(errorMessage, { delay: 100 });

          reject(res);
        });
    });
  };

  const deleteScenarioBlock = (
    block: any,
    isUpdateTree = true,
    isUndoRedoState = true
  ) => {
    return new Promise<void>((resolve, reject) => {
      //setFetchGetScenarioDetail(true);
      MacBotDispatch({
        type: MacBotActionKind.CloseForm,
        payload: { data: null, parentId: null }
      });

      let message = `${t("KnowledgeBasesCreateConditionalScenario/text-01")} "${
        (block.title as string)?.length > 10
          ? (block.title as string).substring(0, 10) + "..."
          : (block.title as string)
      }"?`;

      if (
        block.type == BlockType.VideoButton ||
        block.type == BlockType.VideoLink
      ) {
        message = `${t("KnowledgeBasesCreateConditionalScenario/text-03")}?`;
      }

      ScenarioDeleteConfirm(message, {
        description:
          block?.children?.length > 1 ||
          block.type == BlockType.VideoButton ||
          block.type == BlockType.VideoLink
      }).then((res: any) => {
        if (res) {
          modifyScenario({
            scenarioId: `${currentScenarioId}`,
            data: {
              single: {
                action: "remove",
                data: {
                  id: block.id
                }
              }
            }
          })
            .unwrap()
            .then((data) => {
              toast.success(t("General/key12"));

              editable();
              if (isUndoRedoState) {
                setLastTree({
                  action: "remove",
                  data: block
                });
              }
              dispatch(resetUndoRedoScenario());
              setDataToChart(data);

              resolve(data);
            })
            .catch((res) => {
              if (res.status < 500)
                toast.warn(res?.data?.message || res.message);

              if (res.status >= 500)
                toast.error(res?.data?.message || res.message);

              // if (res.status == 403) {
              //   toast.error(t(AlertsType.ISKBKO014), {
              //     delay: 100
              //   });
              // } else {
              //   toast.error(res?.data?.message, { delay: 100 });
              // }
              reject(res);
            });
        } else {
          reject(new Error("Deletion was not confirmed by the user."));
        }
      });
    });
  };

  const handleManageLivePreview = () => {
    setIsLivePreviewLoading(true);
    setIsLivePreview((prev) => !prev);
    setTimeout(() => {
      setIsLivePreviewLoading(false);
    }, 3000);
  };

  const onPublishScenario = () => {
    publishScenario(`${currentScenarioId}`)
      .unwrap()
      .then((data) => {
        ChatbotRTKService.util.invalidateTags(["GetAllScenarios", "Package"]);
        toast.success(t("KnowledgeBasesCreateConditionalScenario/text-02"), {
          delay: 100
        });
      });
  };

  const closeMobileModalHandler = () => {
    setShowMobileModal(false);
    localStorage.setItem(
      "VSBuilderMobileModal",
      JSON.stringify(client?.sum_identification)
    );
  };

  const getToken = () => {
    const token = localStorage.getItem(
      `${import.meta.env.VITE_STORAGE_PREFIX}_token`
    );

    return token;
  };

  const getFormItems = () => {
    const items = {
      tree: treeData,
      itemData: MacBotState.data,
      loading: modifyScenarioStatus.isLoading,
      createScenarioBlock,
      deleteScenarioBlock,
      changeScenarioBlock,
      parentId: MacBotState.parentId,
      setShow: () => {
        MacBotDispatch({
          type: MacBotActionKind.CloseForm,
          payload: { data: null, parentId: MacBotState.parentId }
        });
      },
      config: configData
    };

    return items;
  };

  const ControlActions = () => {
    const { zoomIn, zoomOut, zoomToElement } = useControls();

    return (
      <div className="tw-w-full tw-h-[36px] tw-bg-gray-50 tw-flex tw-items-center md:tw-justify-between tw-justify-evenly tw-z-0">
        <div className="tw-justify-start tw-items-center tw-flex">
          <Link
            to={`/${MultiLanguageUrl[i18n.language]}/control-panel/chatbots`}
            className="tw-pl-3 tw-pr-4 tw-py-2 tw-bg-transparent md:tw-shadow tw-justify-center tw-items-center tw-gap-2 tw-flex"
          >
            <BiLeftArrowAlt size={20} className="tw-text-gray-400" />
            <div className="tw-text-gray-700 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight md:tw-inline-block tw-hidden">
              {t("Wizard/general/key13")}
            </div>
          </Link>
        </div>

        <div className="tw-flex tw-cursor-pointer">
          <button
            onClick={() => {
              setIsLivePreview((prev) => !prev);
            }}
            className="tw-px-4 tw-py-2 tw-bg-transparent md:tw-border-x tw-border-none tw-border-y-0 md:tw-shadow md:tw-border tw-border-gray-300 tw-justify-center tw-items-center tw-flex"
          >
            <div className="tw-gap-1 tw-flex">
              {isLivePreviewLoading ? (
                <Spinner size="sm" className="tw-mr-2 tw-text-gray-400" />
              ) : (
                <BiPlay size={20} className="tw-text-gray-400" />
              )}

              <span className="tw-text-gray-700 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight md:tw-inline-block tw-hidden">
                {isLivePreview
                  ? t("KnowledgeBasesCreateAssistantBot/btn-04")
                  : t("KnowledgeBasesCreateAssistantBot/btn-03")}
              </span>
            </div>
          </button>
          <button
            className="tw-bg-transparent tw-rounded-none tw-pl-3 tw-pr-4 tw-py-2 tw-justify-center tw-items-center tw-gap-2 tw-flex tw-border-y-0 tw-border-gray-300 md:tw-border-x md:tw-border-solid tw-border-none disabled:tw-border-gray-300"
            onClick={onPublishScenario}
          >
            <BiSlideshow size={20} className="tw-text-gray-400" />

            <span className="tw-text-gray-700 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight md:tw-inline-block tw-hidden">
              {t("Wizard/general/publish")}
            </span>
          </button>
        </div>

        <div className="tw-flex tw-items-center md:tw-justify-start tw-justify-between">
          <button
            className="md:tw-inline-block tw-hidden tw-bg-transparent tw-rounded-none tw-border-y-0 tw-border-gray-300 md:tw-border-x md:tw-border-solid tw-border-none"
            onClick={() => zoomOut()}
          >
            <BiZoomOut size={20} className="tw-text-gray-500" />
          </button>
          <button
            id="HomeButton"
            onClick={() => zoomToElement("STARTBUTTON", scale)}
            className="tw-bg-transparent tw-rounded-none tw-border-y-0 tw-border-gray-300 md:tw-border-x tw-border-none"
          >
            <BiHome size={20} className="tw-text-gray-500" />
          </button>
          <button
            className="md:tw-inline-block tw-hidden tw-bg-transparent tw-rounded-none tw-border-y-0 tw-border-gray-300 md:tw-border-x md:tw-border-solid tw-border-none"
            onClick={() => zoomIn()}
          >
            <BiZoomIn size={20} className="tw-text-gray-500" />
          </button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (!currentScenarioId) {
      return navigate(
        `/${MultiLanguageUrl[i18n.language]}/control-panel/chatbots`
      );
    }
  }, [currentScenarioId]);

  useEffect(() => {
    if (
      (isMobile || window.screen.width <= 480) &&
      isLivePreview &&
      getScenarioDetailData?.id
    )
      toast.dismiss();
  }, [isLivePreview]);

  useEffect(() => {
    if (isLivePreview && getScenarioDetailData?.id) {
      dispatch(handleSetLivePreviewTargetBot(getScenarioDetailData?.id));
    } else {
      dispatch(handleSetLivePreviewTargetBot(""));
    }
  }, [isLivePreview, getScenarioDetailData?.id]);

  useEffect(() => {
    window.addEventListener(
      "message",
      (event: MessageEvent<{ action: string; [key: string]: any }>) => {
        if (
          event.data.action === "resizeIframe" &&
          isLivePreview &&
          event.data.width === 0 &&
          event.data.height === 0
        ) {
          dispatch(handleSetLivePreviewTargetBot(""));

          setIsLivePreview(false);
        }
      }
    );

    return () => {
      window.removeEventListener("message", () => {
        dispatch(handleSetLivePreviewTargetBot(""));
        setIsLivePreview(false);
      });
    };
  }, [isLivePreview]);

  const onItemPressed = (item: any) => {
    if (!videoScenarioAllowedBlocks.includes(item.type))
      return dispatch(handleToggleShowUpgradePlanModal(true));

    setShowPlusModal(false);

    MacBotDispatch({
      type: MacBotActionKind.CloseForm,
      payload: {
        data: null,
        parentId: MacBotState.parentId
      }
    });

    item.action();
  };
  if (isLoading || isLoadingPage) {
    return <LoadingComponent />;
  }

  if (isError)
    return (
      <Row className=" tw-w-5/6 tw-mx-auto tw-mt-2">
        <Alert type="Error">
          <div className="tw-flex tw-items-center tw-gap-4">
            <p className="m-0">{t(AlertsType.ISKBKO003)}</p>
            <Button size="sm" className="px-3" onClick={() => refetch()}>
              {t("KnowledgeBasesCreateConditionalScenario/btn-01")}
            </Button>
          </div>
        </Alert>
      </Row>
    );

  return (
    <TransformWrapper
      limitToBounds={false}
      initialScale={scale}
      minScale={scale}
    >
      {() => (
        <div className="tw-flex flex-row tw-h-full tw-relative lg:tw-overflow-auto tw-overflow-hidden">
          <div className="tw-w-full tw-flex tw-flex-col tw-justify-between">
            {/* Mobile devices Actions */}
            <div className="md:tw-hidden">
              <ControlActions />
            </div>

            {/* Alert of using mobile devices */}
            {showMobileModal && (
              <div className="md:tw-hidden tw-relative tw-p-2 tw-w-full tw-flex tw-justify-start tw-items-start tw-gap-3 tw-bg-blue-50 tw-rounded-md">
                <BiInfoCircle size={20} className="tw-w-6 tw-text-blue-800" />
                <p className="tw-m-0 tw-w-5/6 tw-text-blue-800 tw-text-sm tw-font-medium tw-leading-tight">
                  {t("KnowledgeBasesCreateAssistantBot/text-03")}
                </p>
                <BiX
                  size={24}
                  onClick={() => closeMobileModalHandler()}
                  className="tw-absolute tw-top-2 tw-right-2 tw-text-neutral-400 tw-cursor-pointer"
                />
              </div>
            )}

            <div
              className="tw-h-full tw-w-full"
              style={{ backgroundImage: "url('/dotPattern.png')" }}
            >
              <CreateScenarioTooltip />

              <div
                className={`editor-pattern ${
                  showPlusModal || hasTrueShowKey(MacBotState) ? "is-open" : ""
                }`}
              >
                <React.Fragment>
                  <TransformComponent wrapperClass="customDraggable">
                    <OrgTreeComponent
                      strokeColor="#C1C8CD"
                      strokeWidth="5px"
                      data={data}
                      ref={treeRef}
                      horizontal
                      renderCard={renderCard as any}
                      renderButton={renderButton as any}
                    />
                  </TransformComponent>
                  {/* Desktop actions */}
                  <ControlActions />
                </React.Fragment>
              </div>
            </div>
          </div>

          {/* Add item modal */}

          {showPlusModal && (
            <div className="md:tw-w-[550px] tw-w-full tw-absolute tw-right-0 tw-bg-gray-50 tw-h-full tw-z-[1]">
              {/* Header */}
              <div className="tw-flex tw-flex-row tw-justify-between tw-p-4">
                <div className="tw-h-11 tw-pl-2.5 tw-pr-4 tw-py-2.5  tw-justify-center tw-items-center tw-gap-2 tw-inline-flex">
                  <div className="tw-text-gray-800 tw-text-sm tw-font-semibold tw-font-['Lexend'] tw-leading-tight">
                    {t("AddItemModal/key1")}
                  </div>
                </div>

                <button
                  onClick={() => setShowPlusModal(false)}
                  className="tw-cursor-pointer tw-p-2 tw-bg-gray-100 tw-rounded-[20px] tw-justify-start tw-items-center tw-gap-3 tw-flex tw-border-none tw-text-gray-800"
                  type="button"
                >
                  <BiX className="tw-w-6 tw-h-6 tw-relative" />
                </button>
              </div>
              {/* Content */}
              <div className="tw-flex tw-flex-wrap tw-gap-3 tw-p-1 tw-max-h-[calc(100%-82px)] tw-overflow-y-auto">
                {Object.entries(addBlockUiComponents)
                  .map(([key, value]) => {
                    return { ...value, name: key };
                  })
                  .filter((obj) =>
                    acceptableBlocksToAdd.some((str) => str === obj.name)
                  )
                  .map((item) => (
                    <div
                      role="button"
                      key={item.name}
                      className="tw-w-full tw-p-3 tw-border-none tw-bg-gray-50 hover:tw-bg-gray-100 tw-rounded-2xl tw-justify-start tw-items-start tw-gap-3 tw-inline-flex"
                    >
                      <div
                        role="button"
                        className="tw-w-11 tw-h-11 tw-shrink-0 tw-px-1 tw-pt-[5px] tw-pb-[3px] tw-rounded-[99px] tw-justify-center tw-items-center tw-gap-2.5 tw-flex tw-flex-col"
                        style={{ backgroundColor: item.colors.primary }}
                        onClick={() => onItemPressed(item)}
                      >
                        {item.icon}
                      </div>

                      <div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-gap-1">
                        <div
                          role="button"
                          onClick={() => onItemPressed(item)}
                          className="tw-grow tw-shrink tw-basis-0 tw-flex-col tw-justify-start tw-items-start tw-gap-1 tw-inline-flex"
                        >
                          <div className="tw-text-gray-800 tw-text-sm tw-font-semibold tw-font-['Lexend'] tw-leading-tight tw-text-left">
                            {item.label}
                          </div>
                          <div className="tw-self-stretch tw-text-left tw-text-gray-800 tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-tight">
                            {item.description}
                          </div>
                        </div>

                        {!videoScenarioAllowedBlocks.includes(item.type) ? (
                          <div className="tw-w-11 tw-h-11 tw-p-1 tw-border-none tw-bg-gray-100 tw-rounded-[99px] tw-justify-center tw-items-center tw-gap-2.5 tw-flex tw-flex-col hover:tw-text-primary">
                            <ProBadge variant="small" />
                          </div>
                        ) : (
                          <></>
                        )}
                        <div className="tw-flex tw-items-center tw-gap-3">
                          {item?.name == "BOT_MESSAGE" && (
                            <ScenarioYoutubeVideo
                              item={{
                                ...item,
                                name: "VIDEOBOT_MESSAGE"
                              }}
                            />
                          )}
                          {item?.name != "BOT_MESSAGE" && (
                            <ScenarioYoutubeVideo item={item} />
                          )}

                          <div
                            role="button"
                            onClick={() => onItemPressed(item)}
                            className="tw-w-11 tw-h-11 tw-p-1 tw-border-none tw-bg-gray-100 tw-rounded-[99px] tw-justify-center tw-items-center tw-gap-2.5 tw-flex tw-flex-col hover:tw-text-primary tw-z-[2]"
                          >
                            <BiPlus size={22} />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}

          {MacBotState.isShowResponseForm && !showPlusModal && (
            <VideoScenarioResponseForm {...getFormItems()} />
          )}

          {MacBotState.isShowUserInputForm && (
            <MacBotUserInputForm {...getFormItems()} />
          )}

          {MacBotState.isShowGotoForm && <MacBotGotoForm {...getFormItems()} />}

          {MacBotState.isShowButtonForm && (
            <MacBotButtonForm {...getFormItems()} />
          )}

          {MacBotState.isShowLinkForm && (
            <TextScenarioLinkForm {...getFormItems()} />
          )}
          {MacBotState.isShowVariableForm && (
            <MacBotVariableForm {...getFormItems()} />
          )}
          {MacBotState.isShowHTTPRequestForm && (
            <MacBotHTTPRequestForm {...getFormItems()} />
          )}
          {MacBotState.isShowMakeWebHookForm && (
            <MacBotMakeWebHookForm {...getFormItems()} />
          )}
          {MacBotState.isShowConditionForm && (
            <MacBotConditionForm {...getFormItems()} />
          )}
          {MacBotState.isShowOverrideVariableForm && (
            <MacBotOverrideVariableForm {...getFormItems()} />
          )}
          {MacBotState.isShowCreateVariableForm && (
            <MacBotCreateVariableForm {...getFormItems()} />
          )}
          {MacBotState.isShowLeadForm && <MacBotLeadForm {...getFormItems()} />}
          {MacBotState.isShowMediaForm && (
            <MacBotMediaForm {...getFormItems()} />
          )}
          {MacBotState.isShowAttachmentForm && (
            <MacBotAttachmentForm {...getFormItems()} />
          )}
          {MacBotState.isShowEndOfConversationForm && (
            <EndConversationForm {...getFormItems()} />
          )}
          {MacBotState.isShowNotifyMeByEmailForm && (
            <MacBotNotifyMeByEmailForm {...getFormItems()} />
          )}
          {MacBotState.isShowReceiveAttachmentForm && (
            <MacBotReceiveAttachmentForm {...getFormItems()} />
          )}
          {MacBotState.isShowPassToAi && (
            <MacBotPassToAIForm {...getFormItems()} />
          )}
          {MacBotState.isShowSwitchToChatbot && (
            <MacBotSwitchToChatbotForm {...getFormItems()} />
          )}
        </div>
      )}
    </TransformWrapper>
  );
};

export default VideoScenarioComponent;
